import { getReportingProxyHeaders } from '../../../utils/reportingClient';
import { loadUsers } from '../Users/userFirebase';
import { buildTrackingDataset, getTrackingApiOrigin } from '../Reports/Heatmap/trackingLiveData';

export const buildDashboardTrackingLocations = ({ positions = [], profiles = [], now = new Date(), sinceHours = 24 }) => {
  const cutoff = now.getTime() - sinceHours * 3600000;
  const validPositions = positions.filter(position => {
    const timestamp = Date.parse(position.occurredAt || position.occurred_at);
    return timestamp >= cutoff && timestamp <= now.getTime()
      && position.latitude !== null && position.latitude !== undefined && position.latitude !== ''
      && position.longitude !== null && position.longitude !== undefined && position.longitude !== ''
      && Number.isFinite(Number(position.latitude)) && Math.abs(Number(position.latitude)) <= 90
      && Number.isFinite(Number(position.longitude)) && Math.abs(Number(position.longitude)) <= 180;
  });
  const dataset = buildTrackingDataset({ profiles, livePositions: validPositions, now });
  const agents = dataset.agents.flatMap(agent => {
    const position = dataset.positions.filter(row => row.agentId === agent.id).pop();
    if (!position) return [];
    return [{
      id: agent.id, agentId: agent.id, agentKey: agent.id, agentName: agent.name,
      latitude: position.latitude, longitude: position.longitude,
      accuracyMeters: position.accuracyMeters, occurredAt: position.occurredAt,
      ageMinutes: Math.floor((now.getTime() - Date.parse(position.occurredAt)) / 60000),
      eventLabel: 'Dernière position GPS reçue',
    }];
  });
  return { agents, sinceHours, loadedAt: now.toISOString(), dataSource: 'render-postgres' };
};

export const loadDashboardTrackingLocations = async (options = {}) => {
  const headers = await getReportingProxyHeaders();
  const [response, profiles] = await Promise.all([
    (options.fetchImpl || fetch)(`${getTrackingApiOrigin(options.trackingApi)}/v1/tracking/live`, { headers, cache: 'no-store' }),
    (options.loadUsersImpl || loadUsers)(),
  ]);
  if (!response.ok) throw new Error(`Positions GPS indisponibles (${response.status}).`);
  const report = await response.json();
  return buildDashboardTrackingLocations({ ...options, positions: report.positions, profiles: profiles.users || [] });
};
